import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../components/Header';
import { useParams } from "react-router-dom";
import PlayerRow from '../Counter/components/PlayerRow';
import { getCurrentClubApprovedMembers, getAccountAvatars, getClubChipBalance } from '../../../store/selectors';
import { requestBalanceTransfer } from "../../../store/actionCreators/transfers";

const Transfer = (props) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const { selectedMembers: memberIds, direction } = props.location;
    const clubChipBalance = useSelector(getClubChipBalance);
    const memberList = useSelector(getCurrentClubApprovedMembers);
    const [selectedMemberIds, setSelectedMemberIds] = useState(memberIds);
    const selectedPlayers = memberList.filter(member => memberIds.includes(member._id))
    const avatarList = useSelector(getAccountAvatars);
    const [amount, setAmount] = useState();
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const maxAmount = 50000;
    // const [fee, setFee] = useState(105);

    // useEffect(() => {
    //     console.log(selectedMemberIds, selectedMemberIds.length, "Changed selected array");
    //     setFee(((amount * selectedMemberIds.length) / 100) * 105);
    // }, [amount, selectedMemberIds.length]);

    const makeTransfer = () => {
        dispatch(requestBalanceTransfer({ transferType: direction, memberIds: selectedMemberIds, amount }));
        setAmount('');
    };
    console.log('oops: ', selectedMemberIds, selectedMemberIds.length)
    const selectMember = (e, playerId) => {
        if(selectedMemberIds.includes(playerId) && e.target.type ==='checkbox') {
            setSelectedMemberIds(selectedMemberIds.filter(id => id !== playerId));
        } else if(e.target.type === 'checkbox'){
            let selectedPlayer = selectedMemberIds;
            selectedPlayer.push(playerId);
            setSelectedMemberIds(selectedPlayer);
        }
        setButtonDisabled(!selectedMemberIds.length);
    }

    const validateAmount = (e) => {
        const re = /[0-9\.,]+/g;
        if (!re.test(e.key)) {
          e.preventDefault();
        }
    }

    const changeAmount = (e) => {
      if(e.target.value > maxAmount) {
        setAmount(maxAmount)
      } else {
        setAmount(e.target.value)
      }
    }

    useEffect(()=>{
        setButtonDisabled(!selectedMemberIds.length);
    },[selectedMemberIds]);
    return (
        <div className={`claimBack`}>
            <Header title={direction} to={`/club/${id}/counter`} />
            { direction === "claimBack" ?
                <div className={`maxClaimBackAmount`}>{t('maxClaimBack', {maxAmount})}</div>
            :
            <div className={`clubBalance transferBalance`}>
                <span className={'chipIcon'}></span>
                <span className="balanceNumber">{clubChipBalance}</span>
                <button className="plus plusButton"></button>
            </div>
            }
            <div className={`transferAmount`}>
                <input className={`count`} type="number" value={amount} onChange={changeAmount} onKeyPress={validateAmount} autoFocus={true}/>
                <span className={`multiplier`}>X{selectedMemberIds.length}</span>
            </div>
            <div className={`memberList`}>
                {
                    selectedPlayers.map(player =>
                    <div onClick={(e) => selectMember(e,player._id)} key={player._id}>
                        <PlayerRow  player={player} selected = { true } type={'trade'} avatar={avatarList[player._id]}/>
                    </div>
                    )
                }
            </div>
            {/* { direction === "sendOut" &&
                <div className={`commission`}>
                    <span>{t.formatString(t.tradeCommission, 5)}</span>
                    <span className={`total`}>{t.total}: {fee.toFixed(2)}</span>
                </div>
            } */}
            <div className={`dialogConfirmBox`}>
                <button className="primary" disabled={buttonDisabled} onClick={makeTransfer}>{t('button.confirm')}</button>
            </div>
        </div>
    );
};

export default Transfer;
